require('../../style/index.css');
require('../../popup/index.css');
require('../../overlay/index.css');
require('../../info/index.css');
require('../../image/index.css');
require('../../icon/index.css');
require('../../loading/index.css');
require('../../swipe-new/index.css');
require('../../swipe-item-new/index.css');
require('../../biz-video/index.css');
require('../../rate/index.css');
require('../index.css');